import Filters, { FilterType } from 'components/v2/Filters/Filters';
import Box from '@mui/material/Box';
import React from 'react';
import { useReportContext } from '../../reports/context/ReportContext';
import { useFiltersContext } from '../../../components/v2/Filters/FiltersContext';
import { useShallowEqualEffect } from '../../../utils/use-shallow-effect';
import { useTranslation } from 'utils/translation';

type Props = Pick<React.ComponentProps<typeof Filters>, 'controllerRef'>;

const ReportFilters = ({ controllerRef }: Props) => {
  const { t } = useTranslation();
  const { params, id } = useReportContext();
  const filters = useFiltersContext();

  useShallowEqualEffect(() => {
    filters.commitValues(filters.values);
  }, [filters.values]);

  return (
    <Box>
      <Filters
        items={[
          {
            type: 'query',
            name: 'query',
            label: t('Search'),
          },
          ...params.map((item) => ({
            ...item,
            type: item.type as FilterType,
          })),
        ]}
        controllerRef={controllerRef}
      />
    </Box>
  );
};

export default ReportFilters;
